import dayjs from "dayjs";

import { FacilityIssue, DataNotCollectedIssue } from "./types";
import { LocationData } from "../../../models/LocationData";

export const calculateFacilityIssues = (
  facility: LocationData
): FacilityIssue[] => {
  const issues: FacilityIssue[] = [];

  const dataNotCollectedIssue = generateDataNotCollectedIssue(facility);
  if (dataNotCollectedIssue) {
    issues.push(dataNotCollectedIssue);
  }

  return issues;
};

const generateDataNotCollectedIssue = (
  facility: LocationData
): DataNotCollectedIssue | null => {
  try {
    if (!facility.data_last_collected_at) {
      return {
        title: "data_not_collected",
        params: {
          data_last_collected_at: null,
        },
      };
    }

    // If the data was collected more than 30 hours ago, return an issue
    // Data should be collected every 24 hours, but 30 is used as a buffer
    const dataLastCollectedAt = dayjs(facility.data_last_collected_at);
    const now = dayjs();

    const diffHours = now.diff(dataLastCollectedAt, "hours");
    if (diffHours > 30) {
      return {
        title: "data_not_collected",
        params: {
          data_last_collected_at: facility.data_last_collected_at,
        },
      };
    }

    return null;
  } catch {
    return null;
  }
};
